module.exports = __webpack_public_path__ + "media/images/emblems/Boppelsen-blazon-e4f70e8b016c06b7118aee2802b5a652.svg";